import { t } from 'i18next';
import { NavLink } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { withTranslation, Trans } from 'react-i18next';
import NewsLines from './NewsLines';
import { BREAKING_NEWS_PATH } from '../BreakingNews';
import '../BreakingNews/BreakingNews.css';
import './HomePage.css';

const QUICK_LINKS = [
    { label: 'Admissions', to: '/admissions' },
    { label: 'Calendar', to: '/calendar' },
    { label: 'Contact Us', to: '/contact-us' },
];

function MainBlock() {
    return (
        <>
            {/* Yellow band behind the quick links, welcome text and news */}
            <div className='homeBand'>
            {/* Breaking news teaser: remove this block (and the BreakingNews route) when the news is old */}
            <div className='breakingStrip'>
                <span className='breakingBadge'>{t('breaking_label')}</span>
                <div className='breakingStripText'>
                    <h3>{t('breaking_title')}</h3>
                    <p>{t('breaking_text')}</p>
                </div>
                <NavLink to={BREAKING_NEWS_PATH} className='breakingBtn'>{t('breaking_btn')}</NavLink>
            </div>

            {/* Quick links: edit QUICK_LINKS above to change the buttons (labels are keys in the navigation namespace) */}
            <div className='homeQuickLinks'>
                {QUICK_LINKS.map(link => (
                    <NavLink key={link.to} to={link.to} className='homeQuickLink'>
                        <Trans ns='navigation' i18nKey={link.label} />
                    </NavLink>
                ))}
            </div>

            <Row className='homeMain'>
                <Col lg={7} className='homeWelcome'>
                    <h2 className='homeTitle'>{t('welcome message')}</h2>
                    <h5 className='homeSubTitle' dangerouslySetInnerHTML={{ __html: t('sub welcome message') }}></h5>
                    <p>{t('supplementary community')}</p>
                    <p>{t('proud of our school')}</p>
                    <p>{t('largest school')}</p>
                    <p>{t('since the start of the war')}</p>
                    <p>{t('happy and caring school')}</p>
                    <NavLink to="/contact-us">{t('feel free to contact')}</NavLink>
                </Col>
                <Col lg={5}>
                    <div className='homeNews'>
                        <h3 className='homeNewsTitle'>{t('home_news')}</h3>
                        <NewsLines></NewsLines>
                    </div>
                </Col>
            </Row>
            </div>
        </>
    );
}

export default withTranslation()(MainBlock);